import React from 'react';
// import { ShimmerSectionHeader } from 'react-shimmer-effects';
import { ShimmerThumbnail } from 'react-shimmer-effects';

function FormulaSkeleton() {
    return (
        <div>
            <div className="flex items-center pb-8">
                <h5 className="text-xs4 font-bold text-[#090406]">Formula Settings</h5>
            </div>
            <ShimmerThumbnail height={250} rounded />
            <ShimmerThumbnail height={250} rounded />
            <ShimmerThumbnail height={250} rounded />
        </div>
    );
}

export default FormulaSkeleton;
